module.exports = __webpack_public_path__ + "img/rectangle-code.5860d0c5.svg";